import {del, get, post, put} from './capitalAxios';
import {buildQueryParams} from '../utils';

const BASE = '/api/v1/project';

export const findAllProjects = (companyId) =>
    get(BASE + buildQueryParams([{key: 'companyId', value: companyId}]));

export const createProject = (body) => post(BASE, body);
export const updateProject = (id, body) => put(`${BASE}/${id}`, body);
export const deleteProject = (id) => del(`${BASE}/${id}`);